export const white = "rgba(255,255,255,1)";
export const black = "rgba(0,0,0,1)";
export const darkGrey = "rgba(64,64,64,1)";
export const bgColor = "rgba(238, 237, 243, 1)";

export const primaryFontFamily = "'sailec_regular',Open Sans,sans-serif";
export const secondaryFontFamily = "'sailec_medium',Open Sans,sans-serif";

export const primary = "#17C95F";
export const primaryLight = "#7BDCFF";
export const primaryDark = "#048839";
export const primaryGrey = "#81889c";

export const secondary = "#17C95F";
export const radius = "5px";
export const bold = "bold";
export const normal = "normal";
export const italic = "italic";

export const textColorDark = "#7e7e7e";
export const textColorDarker = "#4A4A4A";
export const textColorLight = "#fff";
export const titleColorDark = "#030A40";
export const titleColorLight = "#fff";

export const spacingLargest = "160px";
export const spacingLarger = "80px";
export const spacingLarge = "60px";
export const spacingMedium = "50px";
export const spacingSmall = "30px";
export const spacingSmaller = "20px";
export const spacingSmallest = "10px";

export const textLargest = "26px";
export const textLarger = "20px";
export const textLarge = "18px";
export const textMedium = "16px";
export const textSmall = "14px";
export const textSmaller = "12px";
export const textSmallest = "10px";

export const titleLargest = "70px";
export const titleLarger = "60px";
export const titleLarge = "50px";
export const titleMedium = "34px";
export const titleSmall = "26px";
export const titleSmaller = "22px";
export const titleSmallest = "20px";

export const maxWidth = "1200px";
export const backgroundColor = bgColor;
export const borderColor = "#b4b2b9";

export const error = "#ff794b";
export const errorLight = "rgba(255,244,244,1)";

export const AccountStatus = {
  KycPeding: "KYC_PENDING",
  AccountOpened: "ACCOUNT_OPENED",
  KycFail: "KYC_FAIL",
  PurchasePending: "PURCHASE_PENDING",
  PurchasePartialSuccess: "PURCHASE_PARTIAL_SUCCESS",
  PortfolioCreated: "PORTFOLIO_CREATED",
  PurchaseFail: "PURCHASE_FAIL",
  WithdrawPending: "WITHDRAW_PENDING",
  WithdrawPartialSuccess: "WITHDRAW_PARTIAL_SUCCESS",
  WithdrawSuccessful: "WITHDRAW_SUCCESSFUL",
};

export const DashboardAction = {
  Buy: "BUY",
  Sell: "SELL",
  CheckStatus: "CHECK_STATUS",
  CreateAccount: "CREATE_ACCOUNT",
};
